import { Resource as e } from "@coveo/platform-client";
// src/resources/OrganizationMonitoringResource.ts
var t = class t extends e {
	static {
		this.baseUrl = "/rest/monitoring/global/organizations";
	}
	getEndpointUsage(e, n = 7) {
		return this.api.get(`${t.baseUrl}/${e}/endpoints/usage?numberOfDaysToInclude=${n}`);
	}
	getRegionUsage(e) {
		return this.api.get(`${t.baseUrl}/${e}/usage/regions`);
	}
	getSearchHubUsage(e, n) {
		return this.api.get(`${t.baseUrl}/${e}/search-hubs/usage?hostname=${n.hostname}&numberOfDaysToInclude=${n.numberOfDaysToInclude}&page=${n.page}&perPage=${n.perPage}`);
	}
};
export { t as OrganizationMonitoringResource };

//# sourceMappingURL=OrganizationMonitoringResource.js.map